import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"20\" height=\"20\" rx=\"10\" fill=\"#E6E6E6\"></rect><g clip-path=\"url(#clip0_8452_30881)\"><path d=\"M6.25 6.25L13.7495 13.75\" stroke=\"#454342\" stroke-width=\"1.5\"></path><path d=\"M13.75 6.25L6.25045 13.75\" stroke=\"#454342\" stroke-width=\"1.5\"></path></g><defs><clipPath id=\"clip0_8452_30881\"><rect width=\"10\" height=\"10\" fill=\"white\" transform=\"translate(5 5)\"></rect></clipPath></defs>", 3)
  ])))
}
export default { render: render }